export default "__VITE_ASSET__CeRKp_Hv__"